import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { createHotelExtra } from "../../api/apiHotelExtras";
import { useNavigate } from "react-router-dom";
import parseError from "../../utils/parseError";

const useCreateHotelExtra = () => {
    const queryClient = useQueryClient();
    const navigate = useNavigate();

    const { mutate: createHotelExtraFn, isPending } = useMutation({
        mutationFn: createHotelExtra,
        onSuccess: (res) => {
            const message = res?.message || "Hotel extra created successfully";
            toast.success(message);
            queryClient.invalidateQueries({ queryKey: ["hotelExtras"] });
            navigate("/hotel-extras");
        },
        onError: (error) => {
            const msg = parseError(error);
            toast.error(msg || "Failed to create hotel extra");
        },
    });

    return { createHotelExtra: createHotelExtraFn, isPending };
};

export default useCreateHotelExtra;
